import { buttonTypes } from '@/shahrzad-assets/shared-constants/buttonTypes'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { confirmModalTexts } from '@/shahrzad-assets/shared-constants/texts'
import { navigateToHome } from '@/shahrzad-assets/shared-utils/navigateToHome'
import { ConfirmModalContext } from '@/shahrzad-assets/shared_components/ConfirmModalContext'
import CustomButton from '@/shahrzad-assets/shared_components/CustomButton'
import { Col, Row } from 'antd'
import React, { useContext } from 'react'
import { sharedPathes } from '../shared-routing/pathe'
import useSendRegisterPushNotif from './useSendRegisterPushNotif'
import { useNavigate } from 'react-router-dom'

const useExit = () => {
  const confirmModalCtx = useContext(ConfirmModalContext)
  const{fetchCancelNotif} =  useSendRegisterPushNotif()
  const navigate = useNavigate();
  const exit = () => {
    confirmModalCtx.setTitle(confirmModalTexts.EXIT_TITLE)
    confirmModalCtx.setDescription(confirmModalTexts.EXIT_DESCRIPTION)
    confirmModalCtx.setComponent(
      <Row gutter={8}>
        <Col span={12}>
          <CustomButton
            width='100%'
            height={dimens.BUTTON_LARGE_HEGHIT}
            styletype={buttonTypes.PRIMARY_OUTLINE}
            onClick={() => confirmModalCtx.hide()}
          >
            {confirmModalTexts.CLOSE}
          </CustomButton>
        </Col>
        <Col span={12}>
          <CustomButton
            width='100%'
            height={dimens.BUTTON_LARGE_HEGHIT}
            styletype={buttonTypes.ERROR_FILL}
            onClick={confirmExit}
          >
            {confirmModalTexts.EXIT_CONFIRM}
          </CustomButton>
        </Col>
      </Row>,
    )
    confirmModalCtx.show()
  }

  const confirmExit = () => {
    if (window.ReactNativeWebView) {
      navigateToHome()
    } else {
      // fetchCancelNotif().finally(()=>{
        localStorage.clear();
        // window.parent.location.replace(import.meta.env.VITE_MAIN_WEB_URL+sharedPathes.ON_BOARDING);
        navigate(sharedPathes.ON_BOARDING, {replace: true})
        confirmModalCtx.hide();
      // })
    }
  }

  return { exit }
}

export default useExit
